<template>
  <div id="Contact">
    <Menu areWeinContact="true"/>
    <!-- Header Inicio -->
    <div class="Contact_colorAzul">
      <section class="Contact_secImage1" :style="{ backgroundImage: 'url(' + firstImage + ')' }">
        <div class="Contact_fondotransparente">
			<h1>Call us at +52 1 55 5407 7599, <br/> or email us at: ops [at] glarus.com.mx </h1>
        </div>
      </section>
      <section class="Contact_secTexto"></section>

      <!-- el div fondoAzulServiciosGrid tiene un fondo transparente que sirve de mascara -->
      <div class="Contact_secImage2" :style="{ backgroundImage: 'url(' + secondImage + ')' }">
        <div class="Contact_fondoAzulServiciosGrid">
          <h1 class="Contact_headGridServices">
            <span>{{titleIcons}}</span>
          </h1>

          <div class="Contact_gridIcons">
            <div class="Contact_formawrap">
              <form action>
                <div class="Contact_fnombre">
                  <input type="text" name="Fname" placeholder="First Name*" v-model="form.first" :class="getValidationClass('first')">
                  <input type="text" name="Lname" placeholder="Last Name*" v-model="form.last" :class="getValidationClass('last')">
                </div>

                <div class="Contact_dataUser">
                  <input type="email" name="emailaddress" placeholder="Email*" v-model="form.email" :class="getValidationClass('email')">
                  <input type="url" name="website" placeholder="Website"  v-model="form.website">
                  <input type="tel" name="tel" placeholder="Phone"  v-model="form.phone">
                </div>

                <div>
                  <textarea name="message" id="message" cols="30" rows="10" placeholder="Message*"  v-model="form.message" :class="getValidationClass('message')"></textarea>
                </div>
                <div class="Contact_boton" @click="validateForm">
                  <span class="message" :class="{'show-message': showMsgSentLbl}">Your message has been sent. We will get in touch shortly.</span>
                  <span type="submit">send</span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <FooterComponent/>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import { validationMixin } from 'vuelidate'
import {
	required,
	minLength,
	maxLength,
    email
} from 'vuelidate/lib/validators'
import Menu from "@/components/Menu2.vue";
import FooterComponent from "@/components/Footer.vue";

import image1 from "../assets/img/contact/image1.jpg";
import image2 from "../assets/img/contact/hall_contactanos.jpg";

export default {
  name: "Contact",
  mixins: [validationMixin],
  data: function() {
    return {
      title: "CONTACT US BY CALLING ANY OF THE NUMBERS BELOW, OR EMAILING US AT<br>ops [at] glarus.com.mx",
      firstImage: image1,
      secondImage: image2,
      // titleImage: "SMART ATTENTION READY TO SERVE YOU",
      titleIcons: "Contact us",
      form: {
        first: '',
        last: '',
        phone: '',
        email: '',
        website: '',
        message: ''
      },
      showMsgSentLbl: false
    };
  },
  validations: {
    form: {
      first: {
        required
      },
      last: {
        required
      },
      email: {
          email,
          required
      },
      message: {
        required
      }
    }
  },
  components: {
    Menu,
    FooterComponent
  },

  mounted: function() {
    this.$nextTick(function() {
      document.title = "Contact Us / Glarus";
    });
  },
  methods: {
    send () {
      Vue.jnx.emailService.sendContactForm(this.form).then(() => {
        this.showMsgSentLbl = true;
        setTimeout(() => {
            this.showMsgSentLbl = false;
        }, 5000)
        this.$v.$reset()
      	// clear
      	this.form = {
          first: '',
          last: '',
          phone: '',
          email: '',
          website: '',
          message: ''
        }
      })
    },
    validateForm () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.send()
      }
    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
            'input-invalid': field.$invalid && field.$dirty
        }
      }
    }
  }
};
</script>

<style lang="less" >
@import url("../assets/less/soloVariables.less");

@placeholderSize: 1em;

.Contact_colorAzul {
  color: @color_Principal_Logo;
}

body,
html {
  min-height: 100%;
}
///
body {
  background-color: rgb(255, 255, 255);
}

//Header
section {
  width: 100%;

  box-sizing: border-box;
}

.Contact_secImage1 {
  height: 70vh;

  background-size: cover;
  background-position: center center;
  background-attachment: fixed;

  @media @mobile {
    display: block;
    background: url(/img/servicios/1/servicio_1.jpg);
    height: 80vh;
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
  }
}

.Contact_secTexto {
  width: 100%;
  padding: 0px 20px;

  background-color: white;
}

.Contact_ceoFrame {
  display: flex;
  flex-flow: column;
  text-align: center;
  //border: 1px solid red;
  //box-sizing: border-box;
  width: 40%;
  padding: 40px 10px;
  margin-left: 60px;
  background-color: rgba(255, 255, 255, 1);
  @media @tablet {
    margin: auto;
    width: 80%;
    padding: 10px 5px;
    background-color: rgba(255, 255, 255, 0.5);
  }
}

.Contact_secImage2 {
  height: auto;

  background-size: cover;
  background-position: center center;
  //background-attachment: fixed;

  display: flex;
  flex-flow: column;

  .Contact_fondoAzulServiciosGrid {
    //el siguiente fondo es la mascara de fondo para opacar la imagen
    background-color: rgba(0, 0, 0, 0.1);

    height: 100%;
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    .Contact_headGridServices {
      padding-top: 30px;
      text-align: center;
      width: 100%;

      span {
        display: inline-block;
        padding: 20px;
        color: white;
        font-weight: 200;
        font-size: 0.8em;
        border-bottom: 1px solid @color_Secundario_Logo;
        border-top: 1px solid @color_Secundario_Logo;
      }
    }
    .Contact_gridIcons {
      display: flex;
      flex-flow: row;
      flex-wrap: wrap;
      justify-content: center;

      // en row justify content center centra horizontal

      width: 90%;

      .Contact_formawrap {
        position: relative;
        display: flex;
        flex-flow: column;
        align-content: center;
        width: 70%;
        padding: 10px;
        padding-bottom: 20px;
        height: 100%;

        @media @desktop {
          width: 80%;
        }
        //border: 1px solid yellow;
        @media @tablet {
        }
        @media @mobile {
          width: 90%;
        }

        textarea {
          resize: none;
          width: 100%;
          margin-top: 20px;
          background-color: rgba(0, 0, 0, 0);
          color: #668073;
          border-style: none;
          border-bottom: 3px solid @color_Secundario_Logo;
          display: block;
        }

        input {
          margin: 5px;
          width: 48%;
          color: #668073;
          display: inline;
          background-color: rgba(0, 0, 0, 0);
          padding-top: 20px;
          border: none;
          border-bottom: 3px solid @color_Secundario_Logo;
        }
        .Contact_fnombre {
          display: flex;
          flex-flow: row;
          justify-content: space-around;
          flex-wrap: wrap;
          //border: 1px solid red;
          @media @tablet {
            //flex-wrap: nowrap;
          }
          input {
            height: 30px;
            @media @tablet {
              width: 100%;
            }
            @media @mobile {
              width: 100%;
            }
          }
        }
        .Contact_dataUser {
          display: flex;
          flex-flow: row;
          justify-content: space-between;
          flex-wrap: wrap;
          input {
            width: 30%;
            height: 30px;
            @media @tablet {
              width: 100%;
            }
            @media @mobile {
              width: 100%;
            }
          }
        }
        .Contact_boton {
          display: flex;
          flex-flow: row;
          justify-content: flex-end;
          padding-top: 20px;
          span {
            cursor: pointer;
            text-transform: uppercase;
            color: white;
            padding: 15px 30px;

            font-size: 0.9em;
            font-weight: 200px;
            background-color: @color_Secundario_Logo;
            transition: background-color 0.5s ease-in-out;
            &:hover {
              background-color: lighten(@color_Secundario_Logo, 10);
            }
          }
          span.message {
            background-color: transparent;
            transition: all 2s linear;
            opacity: 0;
          }
          .show-message {
            opacity: 1 !important;
          }
        }
      }
    }
  }
}
#message {
  border-bottom: 3px solid @color_Secundario_Logo;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: @color_Secundario_Logo;
  font-size: @placeholderSize;
}
::-moz-placeholder {
  /* Firefox 19+ */
  color: @color_Secundario_Logo;
  font-size: @placeholderSize;
}
:-ms-input-placeholder {
  /* IE 10+ */
  color: @color_Secundario_Logo;
  font-size: @placeholderSize;
}
:-moz-placeholder {
  /* Firefox 18- */
  color: @color_Secundario_Logo;
  font-size: @placeholderSize;
}

.Contact_fondotransparente {
  //border: 1px solid red;
  display: flex;
  flex-flow: column;
  justify-content: center;

  width: 100%;
  height: 100%;
  background-color: rgba(4, 61, 114, 0.45);
  h1 {
    //border: 1px solid red;
    color: white;
    font-size: 2.1em;
    font-weight: 300;
    width: 55%;
    padding: 20px 40px;
    padding-top: 100px;

    @media @desktop-xl {
    }

    @media @desktop {
    }

    @media @tablet {
      text-align: left;
      font-size: 2.2em;
      width: 80%;
    }

    @media @mobile {
      text-align: center;
      font-size: 1.5em;
      width: 85%;
      padding: 20px 15px;
      padding-top: 100px;
    }
  }
}

.input-invalid {
  border-bottom: 3px solid red !important;
}
</style>
